
import React, { useEffect } from 'react';
import { Button } from "react-bootstrap";
import PropTypes from "prop-types";


EliminaFerie.propTypes = {
    ferie: PropTypes.object,
    close: PropTypes.func,
    action: PropTypes.func
}

function EliminaFerie({ ferie, close, action, setMessage }) {

    useEffect(() => {
        setMessage([]);
    }, [setMessage]);

    return (
        <div className="formGroup" id="elimina-ferie">
            <p className="text-center">Confermando i dati verranno cancellati definitivamente</p>
            <div className="buttonPopup">
                <Button className="btnGenerale" variant="flat" size="sm" id="cancella-ferie"
                    onClick={() => { action(ferie, close) }}>Conferma</Button>
                <Button className="btnGenerale" variant="flat" size="sm" id="annulla"
                    onClick={close}>Annulla</Button>
            </div>
        </div>)
}



export default EliminaFerie;